/**
 * Modos de extração do serviço de leitura de PDF (PE_CUSTOM).
 *
 * Espelha `legal_drive/file_readers/digital_pdf/extraction_modes.py` no
 * legaldoc_api. Os valores aqui são os do wire da API — os rótulos visíveis
 * ("Standard" / "Next-Set26") vêm do i18n.
 *
 * Atenção ao default: a API assume STANDARD quando o campo não é enviado, mas
 * a tela de novo processamento vem com NEXT_SET26 pré-selecionado. Por isso o
 * DocumentProcessor envia o campo SEMPRE, nunca condicionalmente.
 */
export const EXTRACTION_MODE_STANDARD = "default";
export const EXTRACTION_MODE_NEXT_SET26 = "next-set26";

/** Modo assumido pela API quando o campo não vem no request. */
export const EXTRACTION_MODE_API_DEFAULT = EXTRACTION_MODE_STANDARD;

/** Modo pré-selecionado ao abrir a tela de novo processamento. */
export const EXTRACTION_MODE_UI_DEFAULT = EXTRACTION_MODE_NEXT_SET26;

export const EXTRACTION_MODES = [
  EXTRACTION_MODE_STANDARD,
  EXTRACTION_MODE_NEXT_SET26,
];

/* Valor gravado durante o desenvolvimento do modo novo, antes do rename para
   `next-set26`. Nunca chegou a produção; existe aqui só para que os jobs de
   teste não apareçam sem rótulo no histórico. Pode sair junto com o
   `_LEGACY_ALIASES` do backend. */
const LEGACY_VALUES = { basic: EXTRACTION_MODE_NEXT_SET26 };

/**
 * Normaliza o modo lido de um job para um dos valores conhecidos.
 *
 * Jobs anteriores ao parâmetro não têm a chave e caem em STANDARD — que é o
 * que o worker de fato usa ao executá-los. Um valor desconhecido volta cru,
 * para a UI mostrar o que está gravado em vez de mentir.
 */
export function normalizeExtractionMode(value) {
  if (value == null || value === "") {
    return EXTRACTION_MODE_STANDARD;
  }
  const mode = String(value).trim().toLowerCase();
  return LEGACY_VALUES[mode] || mode;
}

/**
 * Lê o modo de extração de um job da listagem (`input_params.extraction_mode`).
 * Aceita input_params como dict ou como string JSON.
 */
export function getJobExtractionMode(job) {
  let inputParams = job?.input_params;
  if (typeof inputParams === "string") {
    try {
      inputParams = JSON.parse(inputParams);
    } catch {
      inputParams = null;
    }
  }
  return normalizeExtractionMode(inputParams?.extraction_mode);
}
